import { render, staticRenderFns } from "./MatchesSetting.vue?vue&type=template&id=c47bf8ee"
import script from "./MatchesSetting.vue?vue&type=script&lang=js"
export * from "./MatchesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports